export class NativeOttSettings {
  constructor(overrides) {
    const defaults = {
      supportedLanguages: ['EN'],
      defaultLanguage: 'EN',
      vendorList: null,
      showCategoriesBtn: true,
      showVendorsBtn: true,
      showPrivacyPolicyBtn: true,
      showCustomBtn: false,
      showRejectAllBtn: false,
      showSaveAndExitBtn: false,
      showAcceptAllBtn: true,
      globalBackgroundColor: '#e3e3e3',
      globalFont: {
        fontFamily: 'arial, helvetica, sans-serif'
      },
      globalButtonUnfocusColor: '#575757',
      globalButtonFocusColor: '#ffffff',
      globalButtonUnfocusFontColor: '#ffffff',
      globalButtonFocusFontColor: '#000000',
      globalLongButtonUnfocusColor: '#f1f2f6',
      globalLongButtonFocusColor: '#ffffff',
      globalLongButtonUnfocusFontColor: '#000000',
      globalLongButtonFocusFontColor: '#000000',
      globalLogo: ''
    };
    Object.assign(this, defaults, overrides);
  }
}
export const NativeOttTypes = {
  'Native OTT Global Settings': {
    vendorList: {
      title: 'Vendor List Preview',
      type: 'VendorList'
    },
    defaultLanguage: {
      title: 'Default Language',
      type: 'Language'
    },
    showAcceptAllBtn: {
      title: 'Show Accept All Button (Home View Only)',
      type: 'Switch'
    },
    showSaveAndExitBtn: {
      title: 'Show Save and Exit Button (Home View Only)',
      type: 'Switch'
    },
    showRejectAllBtn: {
      title: 'Show Reject All Button (Home View Only)',
      type: 'Switch'
    },
    showCategoriesBtn: {
      title: 'Show Categories Button (Home View Only)',
      type: 'Switch'
    },
    showVendorsBtn: {
      title: 'Show Vendors Button (Home View Only)',
      type: 'Switch'
    },
    showPrivacyPolicyBtn: {
      title: 'Show Privacy Policy Button (Home View Only)',
      type: 'Switch'
    },
    showCustomBtn: {
      title: 'Show Custom Button (Home View Only)',
      type: 'Switch'
    }
  },
  'Native OTT Style Settings': {
    globalBackgroundColor: {
      title: 'Backgrounds',
      type: 'ColorPicker'
    },
    globalFont: {
      title: 'Fonts',
      type: 'Font'
    },
    globalButtonUnfocusColor: {
      title: 'Buttons Unfocused Color',
      type: 'ColorPicker'
    },
    globalButtonFocusColor: {
      title: 'Buttons Focused Color',
      type: 'ColorPicker'
    },
    globalButtonUnfocusFontColor: {
      title: 'Buttons Unfocused Font Color',
      type: 'ColorPicker'
    },
    globalButtonFocusFontColor: {
      title: 'Buttons Focused Font Color',
      type: 'ColorPicker'
    },
    globalLongButtonUnfocusColor: {
      title: 'Long Buttons Unfocused Color',
      type: 'ColorPicker'
    },
    globalLongButtonFocusColor: {
      title: 'Long Buttons Focused Color',
      type: 'ColorPicker'
    },
    globalLongButtonUnfocusFontColor: {
      title: 'Long Buttons Unfocused Font Color',
      type: 'ColorPicker'
    },
    globalLongButtonFocusFontColor: {
      title: 'Long Buttons Focused Font Color',
      type: 'ColorPicker'
    },
    globalLogo: {
      title: 'Logo',
      type: 'Input'
    }
  }
};